import React, { useMemo, useState } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { billingAPI } from '../services/api';

const StripePaymentButton = ({ publishableKey, month, totalAmount, onSuccess, compact = false }) => {
  const stripePromise = useMemo(() => (
    publishableKey ? loadStripe(publishableKey) : null
  ), [publishableKey]);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  if (!publishableKey || totalAmount <= 0) {
    return null;
  }

  const handlePayment = async () => {
    try {
      setSubmitting(true);
      setError('');

      const stripe = await stripePromise;
      if (!stripe) {
        throw new Error('Stripe could not be initialized.');
      }

      const paymentIntentRes = await billingAPI.createPaymentIntent({ month });
      const { clientSecret, invoiceId } = paymentIntentRes.data;

      const result = await stripe.confirmCardPayment(clientSecret);
      if (result.error) {
        throw new Error(result.error.message || 'Payment could not be completed.');
      }

      await billingAPI.confirmPayment({
        paymentIntentId: result.paymentIntent.id,
        invoiceId
      });

      if (onSuccess) {
        await onSuccess();
      }
    } catch (err) {
      setError(err?.response?.data?.error || err.message || 'Payment could not be completed.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div>
      <button
        type="button"
        onClick={handlePayment}
        className="btn btn-primary"
        disabled={submitting}
        style={compact ? { width: '100%' } : undefined}
      >
        {submitting ? 'Processing...' : 'Pay with Stripe'}
      </button>
      {error && <div style={{ color: '#dc2626', marginTop: 8 }}>{error}</div>}
    </div>
  );
};

export default StripePaymentButton;
